import { FROM_SUPERAPP } from '@app/constants/fromParams';
import { TAB_PARAMS } from '@app/constants/tabParams';

export const isPopularVisible = (
  fromRoute: string,
  activeTab: string | null
) => {
  if (
    (fromRoute === FROM_SUPERAPP && activeTab !== TAB_PARAMS.POPULAR) ||
    activeTab === TAB_PARAMS.CATEGORIES
  ) {
    return false;
  }
  return true;
};
